import React from 'react'
import { useLocation } from 'react-router-dom'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { cn } from 'src/shared/components/ui/utils'

import { SideBar } from './Sidebar'
import { TopNavBar } from './TopNavBar'
import { useNavItems } from './consts'
import {
  paths,
  isOrderWorkspacePath,
  isGuidedAssistantPath,
} from 'src/routes/paths'

export function NavBar({
  children,
  mode,
  variant = 'light',
}: {
  children: React.ReactNode
  mode: 'admin' | 'user'
  variant?: 'light' | 'dark'
}) {
  const { navItemsAdmin, navItemsCustomer, navItems } = useNavItems()
  const location = useLocation()
  const isAdminShell =
    mode === 'admin' || location.pathname.startsWith(paths.admin)
  const shellNavItems = isAdminShell ? navItemsAdmin : navItemsCustomer

  // Determine if this is the open website (home, about, etc.) vs app pages (/app, admin)
  const isOpenWebsite =
    !location.pathname.startsWith(paths.myAccount) &&
    !location.pathname.startsWith(paths.admin)
  const isHomeOverlayNav = location.pathname === paths.home
  const isGuidedAssistantRoute = isGuidedAssistantPath(location.pathname)
  const isFullHeightOpenRoute = isGuidedAssistantRoute
  const isWorkspacePage = isOrderWorkspacePath(location.pathname)

  // Open website - no wrapper, just header overlay and content
  if (isOpenWebsite) {
    return (
      <Column
        className={cn(
          'min-h-dvh flex flex-col',
          isFullHeightOpenRoute && 'h-dvh'
        )}
      >
        <TopNavBar
          navItems={navItems}
          variant={variant}
          overlayNav={isHomeOverlayNav}
        />
        {isHomeOverlayNav ? (
          children
        ) : isFullHeightOpenRoute ? (
          <Column className="min-h-0 w-full min-w-0 flex-1 flex flex-col">
            {children}
          </Column>
        ) : (
          children
        )}
      </Column>
    )
  }

  // App pages (admin or my-account) — /app always uses customer nav
  return (
    <Column className="h-dvh">
      <Row className="flex-1 overflow-hidden theme-bg">
        {!isWorkspacePage && (
          <SideBar navItems={isAdminShell ? shellNavItems : navItemsCustomer} />
        )}

        <Column
          className={cn(
            'flex-1 min-w-0 overflow-auto',
            isWorkspacePage && 'h-full'
          )}
        >
          {children}
        </Column>
      </Row>
    </Column>
  )
}
